import { lazy } from 'react';
import { withSuspense } from '../../../components';

export { default as Translate } from './Translate';
export { default as DeletedMessage } from './DeletedMessage';
export const Textmessage = withSuspense(lazy(() => import('./Textmessage')));
export const ImageComponent = withSuspense(lazy(() => import('./ImageComponent')));
export const ContactComponent = withSuspense(lazy(() => import('./ContactComponent/index')));
export const LocationComponent = withSuspense(lazy(() => import('./LocationComponent/LocationComponent')));
export const VideoComponent = withSuspense(lazy(() => import('./VideoComponent')));
export const AudioComponent = withSuspense(lazy(() => import('./AudioComponent/AudioComponent')));
export const FileComponent = withSuspense(lazy(() => import('./FileComponent/FileComponent')));
export const AudioRecorder = withSuspense(lazy(() => import('./AudioRecorder/index')));
export const ChannelInvite = withSuspense(lazy(() => import('./ChannelInvite')));
export { default as WebChannelMediaPreview } from './WebChannelMediaPreview';
export * from './Reactions';
